export class ClientTimer {
    constructor (logger) {
        this.#reset();
        this.$log = logger;
    }

    #reset () {
        this.startTime = null;
        this.finishTime = null;
        this.from = null;
        this.to = null;
    }

    /**
     * To be called before client-side navigation to start the timer.
     * @param {string} url - The path of the current page (before navigationg) without query string. You should probably pass in `$route.path`.
     * @returns {void}
     */
    start (path) {
        this.startTime = Date.now();
        this.from = path;
    }

    /**
     * To be called after client-side navigation for logging and timing.
     * @param {string} path - The path of the current page without query string. You should probably pass in `$route.path`.
     * @param {string} query - The query string of the current page.
     * @returns {void}
     */
    finish (path, query) {
        if (this.startTime === null) return;

        this.finishTime = Date.now();
        this.to = path;
        const timeTaken = this.finishTime - this.startTime;
        this.$log.info(`Client navigation from ${this.from} to ${this.to} took ${timeTaken}ms`, 'core-team', {
            'time-taken': timeTaken,
            'cs(Referer)': this.from,
            'cs-uri-stem': this.to,
            'cs-uri-query': query
        });

        this.#reset();
    }
}

export default ({ $log }, inject) => {
    const timer = new ClientTimer($log);

    // this.$navigationTimer
    inject('navigationTimer', timer);
};
